import { useEffect } from "react";

// ponytail: module-level cache of Image objects. Holding a reference keeps the
// image alive in the browser's memory cache, so a screen that unmounts and later
// remounts paints instantly instead of re-fetching/re-decoding.
// Grows with the number of distinct URLs seen; add an LRU cap if that ever hurts.
const cache = new Map<string, HTMLImageElement>();

export const preloadImages = (urls: (string | null | undefined)[]) => {
  for (const url of urls) {
    if (!url || cache.has(url)) continue;
    const img = new Image();
    img.src = url;
    cache.set(url, img);
  }
};

/** Preloads and pins the given images so remounting a screen doesn't reload them. */
export const usePreloadImages = (urls: (string | null | undefined)[]) => {
  const key = urls.filter(Boolean).join("|");
  useEffect(() => {
    preloadImages(urls);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);
};
